import { memo, useMemo } from "react";
import { ResourceView } from "../../../../dto/ResourceView";
import React from "react";
import { ViewSiteButton } from "../../news/ViewSiteButton";
import { LSResultItemLayout } from "./LSResultItem/LSResultItemLayout";
import { LSResultItemCheckbox } from "./LSResultItem/LSResultItemCheckbox";
import { LSResultItemAuthor } from "./LSResultItem/LSResultItemAuthor";
import { LSResultItemTitle } from "./LSResultItem/LSResultItemTitle";
import { LSResultItemBookjacket } from "./LSResultItem/LSResultItemBookjacket";
import { LSResultItemAddToListButton } from "./LSResultItem/LSResultItemAddToListButton";
import { Box, Chip } from "@mui/material";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";

export const ContentDMOrRSSFormat = ({ resource }: ContentDMOrRSSItemProps) => {
  const { translate } = useLanguage();
  const format = useMemo(() => {
    if (resource.rtype === 2) {
      return translate("rssFeedItem");
    }
    if (resource.rtype === 3) {
      return translate("contentDMFormat");
    }
    return resource.format;
  }, [resource.rtype, resource.format, translate]);

  return <Chip variant="outlined" label={format} />;
};

interface ContentDMOrRSSItemProps {
  resource: ResourceView | ResourceDWR;
}
export const ContentDMOrRSSItem = memo(
  function ContentDMOrRSSItem({ resource }: ContentDMOrRSSItemProps) {
    const actionsComponent = (
      <>
        <ViewSiteButton site={resource} />
        <LSResultItemAddToListButton resource={resource} />
      </>
    );

    return (
      <LSResultItemLayout
        titleComponent={<LSResultItemTitle resource={resource} />}
        bookjacketComponent={<LSResultItemBookjacket resource={resource} />}
        checkboxComponent={<LSResultItemCheckbox resource={resource} />}
        actionsComponent={actionsComponent}
        authorComponent={
          <LSResultItemAuthor shortAuthor={resource.shortAuthor} />
        }
      >
        <Box display="flex" alignItems="center" gap={2}>
          <Box>
            <ContentDMOrRSSFormat resource={resource} />
          </Box>
        </Box>
      </LSResultItemLayout>
    );
  },
  (prevProps, nextProps) => prevProps.resource.id === nextProps.resource.id
);
